"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Shop() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const metadata = [{
    label: "FLAVORS IN ROTATION",
    value: "24"
  }, {
    label: "ARTISANAL / CLASSIC",
    value: "16 / 8"
  }, {
    label: "LOCALLY SOURCED",
    value: "100%"
  }, {
    label: "FRESH BATCHES",
    value: "DAILY"
  }];
  return <section data-section-id="1090" id="shop-title" className="relative bg-background text-foreground py-32 md:py-44 px-5 md:px-12 overflow-hidden">
      {}
      <div className="relative max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-8">
          {}
          <div ref={leftRef} className="lg:col-span-7 relative" style={{
          opacity: leftVisible ? 1 : 0,
          transform: leftVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 700ms cubic-bezier(0.22, 1, 0.36, 1), transform 700ms cubic-bezier(0.22, 1, 0.36, 1)"
        }}>
            {}
            <div aria-hidden="true" className="absolute -top-12 -left-4 md:-left-8 pointer-events-none select-none font-serif leading-none" style={{
            fontSize: "clamp(12rem, 22vw, 22rem)",
            color: "hsl(0 0% 12% / 0.05)",
            zIndex: 0
          }}>
              01
            </div>

            {}
            <div className="relative z-10 flex items-center gap-3 mb-12 md:mb-16">
              <span className="font-sans uppercase" style={{
              fontSize: "clamp(0.7rem, 0.8vw, 0.8125rem)",
              letterSpacing: "0.15em",
              color: "hsl(0 100% 71%)"
            }}>
                EDITION 01 — The Collection
              </span>
              <span aria-hidden="true" className="inline-block w-1 h-1" style={{
              backgroundColor: "hsl(0 100% 71%)"
            }} />
            </div>

            {}
            <h1 className="relative z-10 font-serif text-foreground" style={{
            fontSize: "clamp(3.25rem, 7vw, 6.5rem)",
            letterSpacing: "-0.02em",
            lineHeight: "0.96",
            fontWeight: 500
          }}>
              The Art of{" "}
              <span className="italic inline-block" style={{
              opacity: leftVisible ? 1 : 0,
              transition: "opacity 200ms ease-out",
              transitionDelay: leftVisible ? "400ms" : "0ms"
            }}>
                Cream
              </span>
            </h1>

            {}
            <p className="relative z-10 mt-8 font-sans" style={{
            fontSize: "clamp(1.25rem, 1.6vw, 1.625rem)",
            lineHeight: 1.5,
            maxWidth: "480px",
            color: "hsl(0 0% 40%)",
            fontWeight: 400
          }}>
              Every scoop in our collection is handcrafted using heritage techniques and the finest seasonal ingredients from local dairies.
            </p>
          </div>

          {}
          <div ref={rightRef} className="lg:col-span-5 lg:pl-8 flex flex-col gap-12 mt-4 lg:mt-2" style={{
          opacity: rightVisible ? 1 : 0,
          transform: rightVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 700ms cubic-bezier(0.22, 1, 0.36, 1) 200ms, transform 700ms cubic-bezier(0.22, 1, 0.36, 1) 200ms"
        }}>
            {}
            <ul className="flex flex-col gap-4">
              {metadata.map((item, i) => <li data-index={i} key={i} className="flex items-center gap-3 font-sans" style={{
              fontSize: "0.8125rem",
              letterSpacing: "0.08em",
              lineHeight: 1.4,
              color: "hsl(0 0% 40%)"
            }}>
                  <span aria-hidden="true" className="inline-block w-1 h-1 shrink-0" style={{
                backgroundColor: "hsl(0 100% 71%)"
              }} />
                  <span className="uppercase">
                    {item.label} — <span className="text-foreground">{item.value}</span>
                  </span>
                </li>)}
            </ul>

            {}
            <div className="relative w-[120px] h-[120px] opacity-40" aria-hidden="true">
              <svg viewBox="0 0 120 120" width="120" height="120" fill="none" stroke="hsl(0 0% 12%)" strokeWidth="0.5">
                <circle cx="60" cy="60" r="58" />
                <circle cx="60" cy="60" r="42" />
                <circle cx="60" cy="60" r="26" />
                <line x1="60" y1="2" x2="60" y2="118" />
                <line x1="2" y1="60" x2="118" y2="60" />
                <circle cx="60" cy="60" r="1.5" fill="hsl(0 100% 71%)" stroke="none" />
              </svg>
            </div>
          </div>
        </div>

        {}
        <div className="relative mt-20 md:mt-28">
          <div className="w-full h-px" style={{
          backgroundColor: "hsl(0 0% 92%)"
        }} />
          <div className="absolute inset-0 flex items-center justify-between">
            <span aria-hidden="true" className="block w-1 h-1" style={{
            backgroundColor: "hsl(0 100% 71%)"
          }} />
            <span aria-hidden="true" className="block w-1 h-1" style={{
            backgroundColor: "hsl(0 100% 71%)"
          }} />
            <span aria-hidden="true" className="block w-1 h-1" style={{
            backgroundColor: "hsl(0 100% 71%)"
          }} />
          </div>
        </div>

        {}
        <div className="mt-6 font-mono uppercase" style={{
        fontSize: "0.75rem",
        letterSpacing: "0.16em",
        color: "hsl(0 0% 40%)"
      }}>
          40.7128° N / 74.0060° W — Brooklyn
        </div>
      </div>
    </section>;
}